import { render, staticRenderFns } from "./ToCart.vue?vue&type=template&id=6b8a59e5"
import script from "./ToCart.vue?vue&type=script&lang=js"
export * from "./ToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports